
export function getChinaDateAndWeek(){
    //   that.newDate = new Date().toLocaleString()
    const weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
    const newDate =new Date();
    // 日期
    const year = newDate.getFullYear();
    const month = newDate.getMonth() + 1;
    const day = newDate.getDate();
    return { 
        CurrentDate:newDate,
        day:month + "月" + day + "日",
        week:weeks[newDate.getDay()],
        time:newDate.toLocaleTimeString()
    }
}

/**
 * 精确计算工具（解决浮点数精度问题）
 */
export const calc = {
    // 加法
    add(arg1, arg2) {
        if (arg1 == null || arg1 == undefined || arg1 === '') {
            arg1 = 0
        }
        if (arg2 == null || arg2 == undefined || arg2 === '') {
            arg2 = 0
        }
        var r1, r2, m, n;
        try {
            r1 = arg1.toString().split(".")[1].length
        } catch (e) {
            r1 = 0
        };
        try {
            r2 = arg2.toString().split(".")[1].length
        } catch (e) {
            r2 = 0
        };
        m = Math.pow(10, Math.max(r1, r2));
        //动态控制精度长度
        n = (r1 >= r2) ? r1 : r2;
        return ((arg1 * m + arg2 * m) / m).toFixed(n) * 1;
    },
  };


// WEBPACK FOOTER //
// ./src/utils/tools.js